<template>
    <div class="sandbox-wrapper">
        <div class="lw-cols one-row one-row-tl one-row-tp one-row-sl one-row-sp">
            <div class="col flex-item span_12_of_12-all no-padding mb-2rem">
                <div class="learnworlds-overline-text learnworlds-element no-margin-bottom">
                    Card number
                </div>
                <div ref="cardNumber"
                     class="learnworlds-input-solid-light learnworlds-input 
                            learnworlds-input-normal learnworlds-element">
                    4242 4242 4242 4242
                </div>
            </div>
        </div>
        <div class="lw-cols multiple-rows multiple-rows-tl multiple-rows-tp multiple-rows-sl multiple-rows-sp">
            <div class="col flex-item span_6_of_12 span_6_of_12-tl span_6_of_12-tp span_6_of_12-sl span_12_of_12-sp no-padding mb-2rem">
                <div class="learnworlds-overline-text learnworlds-element no-margin-bottom">
                    Expiration date
                </div>
                <div ref="cardExpiry"
                     class="learnworlds-input-solid-light learnworlds-input 
                            learnworlds-input-normal learnworlds-element">
                    12 / 34
                </div>
            </div>
            <div class="col flex-item span_6_of_12 span_6_of_12-tl span_6_of_12-tp span_6_of_12-sl span_12_of_12-sp no-padding mb-2rem">
                <div class="learnworlds-overline-text learnworlds-element no-margin-bottom">
                    CVV
                </div>
                <div ref="cardCvc"
                     class="learnworlds-input-solid-light learnworlds-input 
                            learnworlds-input-normal learnworlds-element">
                    123
                </div>
            </div>
        </div>
        <div class="sandbox-card-hover-notfication">
            <span>Form is prefilled for testing purposes</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "SandboxCardInline"
    }
</script>
<style scoped>
    .sandbox-wrapper{
        position: relative;
    }

    .sandbox-card-hover-notfication{
        display: none;
        position: absolute;
        top:0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.7);
        z-index: 2;
        
    }
    .sandbox-wrapper:hover .sandbox-card-hover-notfication{
        display: block;
    }

    .sandbox-card-hover-notfication span{
        position: absolute;
        top:50%;
        left:50%;
        transform: translate(-50%, -50%);
        font-size: 15px;
        font-weight: bold;
        color: #fff;

    }

</style>

